<template>
    <kt-form-group>
        <a :href="link" download target="_blank">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-download" aria-hidden="true"></i>
                    </span>
                </div>
                <kt-form-label class="form-control" style="cursor: pointer">
                    {{ title }}
                </kt-form-label>
            </div>
        </a>
    </kt-form-group>
</template>

<script>
export default {
    props: {
        link: {
            require: true,
        },
        title: {
            require: true,
        },
    },
}
</script>

<style scoped>
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
</style>